export default __webpack_public_path__ + "navigation-examples-custom-server-thumbnail-480-1447fe865079455ded8863449273a645.png";